const HeaderItems = {
    SCHEDULE: 'SCHEDULE',
    EDIT: 'EDIT'
}

export default HeaderItems



// WEBPACK FOOTER //
// ./src/common/HeaderItems.js